<div *ngIf="showLoader" class="loading-model property">
  <p-progress-spinner></p-progress-spinner>
</div>
<div class="add-button-wrapper" [ngClass]="{ 'beta-access-enabled': isBetaAccessPrivilegeConsumable }">
  <span [pTooltip]="imports.length >= 10 ? ('MAX_IMPORT_TOOLTIP' | translate) : null" tooltipPosition="top">
    <p-button
      type="button"
      [label]="'ADD_IMPORT' | translate"
      icon="pi pi-plus"
      class="new-btn"
      [disabled]="imports.length >= 10 || disableField"
      (onClick)="addImports()"
    ></p-button>
  </span>
</div>
<p-accordion
  [ngClass]="{ 'beta-access-enabled': isBetaAccessPrivilegeConsumable }"
  [value]="selected"
  (valueChange)="selected = $event"
  *ngIf="imports.length > 0"
  [expandIcon]="'pi pi-chevron-down'"
  [collapseIcon]="'pi pi-chevron-up'"
  [transitionOptions]="'300ms cubic-bezier(0.4, 0, 0.2, 1)'"
>
  @for (imp of imports | uiFilter: searchTerm : ['name']; track $index; let i = $index) {
    <p-accordion-panel [value]="imp?.sid" class="border-class" [ngClass]="{ 'bor-err': imp.err }">
      <p-accordion-header>
        <div class="header-delete-icon-wrapper">
          <div class="imp-header-wrapperss">
            <div class="imp-header">{{ imp.name }}</div>
          </div>
          <div class="del-icon-wrapper" [ngClass]="{ disableField: disableField }">
            <button
              (click)="delImp($event, i)"
              *ngIf="imp.name"
              type="button"
              class="delete-icon"
              aria-hidden="true"
              showDelay="100"
              hideDelay="100"
              [disabled]="disableField"
              [pTooltip]="'DELETE' | translate"
              tooltipPosition="top"
            >
              <svg-icon src="assets\images\svg\trash.svg"></svg-icon>
            </button>
          </div>
        </div>
      </p-accordion-header>

      <p-accordion-content>
        <div class="position-relative row form-group prop-elems">
          <label class="col-sm-6 col-form-label" for="impname-{{ i }}"
            >{{ 'IMPORT_TEMPLATE_NAME' | translate }}
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              appendTo="body"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              [pTooltip]="'IMPORT_TEMPLATE_NAME_TOOLTIP' | translate"
            ></i>
          </label>
          <div class="col-sm-6 input-ctrl pl-0">
            <input
              [name]="imp.name"
              id="impname-{{ i }}"
              type="text"
              maxlength="64"
              [(ngModel)]="imp.name"
              alphaNumWithSpace
              [ngClass]="{ 'bor-err': imp.err }"
              (focusout)="onNameChange($event, imp)"
              [disabled]="disableField"
              class="form-control form-control-sm"
            />
          </div>
        </div>
        <div class="position-relative row form-group prop-elems">
          <label class="col-sm-6 col-form-label" for="fields-for-import-template"
            >{{ 'FIELDS_FOR_IMPORT_TEMPLATE' | translate }}
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              appendTo="body"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              [pTooltip]="'FIELDS_FOR_IMPORT_TEMPLATE_TOOLTIP' | translate"
            ></i>
          </label>
          <div class="col-sm-6 input-ctrl pl-0 d-block">
              <div class="p-inputgroup pl-2" id="fields-for-import-template" [ngClass]="{ 'bor-err': imp.errorMsg }">
                <div class="fields importfieldlist" *ngIf="imp?.fields.length">
                  <span *ngFor="let field of imp.fields" class="field-name mr-1">
                    {{ field.altName ? field.altName : fieldIdMap[field.sid] }}
                  </span>
                </div>
                <span class="p-inputgroup-addon">
                  <button
                    type="button"
                    class="p-element p-component p-button-icon-only"
                    [title]="'REORDER' | translate"
                    (click)="togglePickList($event, imp)"
                    [disabled]="disableField"
                  >
                    <i
                      class="fa fa-exclamation-circle error-icon1"
                      *ngIf="imp.errorMsg"
                      (mouseenter)="toggleWarningPopup()"
                      (mouseleave)="toggleWarningPopup()"
                    ></i>
                    <i class="pi pi-pencil"></i>
                  </button>
                </span>
              </div>
              <div class="warning-wrapper">
                <div class="text-danger val-err" *ngIf="showErrorPopUp">
                  <div class="warning-header">
                    <p>{{ 'WARNING' | translate }}</p>
                    <i class="pi pi-times"></i>
                  </div>
                  {{ imp.errorMsg }}
                </div>
              </div>
          </div>
        </div>
        <div class="position-relative row form-group prop-elems">
          <label class="col-sm-6 col-form-label" [for]="imp.notifyMail"
            >{{ 'NOTIFY_EMAIL' | translate }}
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              appendTo="body"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              [pTooltip]="'NOTIFY_EMAIL_TOOLTIP' | translate"
            ></i
          ></label>
          <div class="col-sm-6 input-ctrl pl-0">
            <p-checkbox
              [binary]="true"
              [disabled]="disableField"
              [inputId]="imp.notifyMail"
              [name]="imp.notifyMail"
              [attr.id]="imp.notifyMail"
              styleClass="mt-2"
              [(ngModel)]="imp.notifyMail"
              (onChange)="onNotifyMailChange($event, imp)"
            ></p-checkbox>
          </div>
        </div>
        <div class="position-relative row form-group prop-elems" *ngIf="imp.notifyMail">
          <label class="col-sm-6 col-form-label" for="email-template"
            >{{ 'EMAIL_TEMPLATE' | translate }}
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              appendTo="body"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              [pTooltip]="'EMAIL_TEMPLATE_TOOLTIP' | translate"
            ></i
          ></label>
          <div class="col-sm-6 input-ctrl pl-0" id="email-template">
            <vb-mail-template
              [element]="imp"
              [(ngModel)]="imp.mailTemplateId"
              [disableField]="disableField"
              [dataFrom]="'import'"
              (opValue)="onMailChanges($event, imp)"
              [formDetails]="formData"
            >
            </vb-mail-template>
          </div>
        </div>
        <div class="position-relative row form-group prop-elems">
          <label class="col-sm-6 col-form-label" for="source-file-types"
            >{{ 'SOURCE_FILE_TYPES' | translate }}
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              appendTo="body"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              [pTooltip]="'SOURCE_FILE_TYPES_TOOLTIP' | translate"
            ></i
          ></label>
          <div class="col-sm-6 input-ctrl pl-0" id="source-file-types">
            <vb-checkbox-group>
              <span class="d-inline-flex justify-content-between" *ngFor="let option of srcFileTypes">
                <p-checkbox
                  (onChange)="handlefileTypeChange($event, imp)"
                  [(ngModel)]="imp.fileTypes"
                  [value]="option.value"
                  [option]="option.name"
                  [name]="option.name"
                  [label]="option.name"
                  [inputId]="option.name"
                  [disabled]="disableField"
                  labelStyleClass="pr-2 mb-0"
                />
                <label [for]="option.name" class="mx-2 mb-0"> {{ option.name }} </label>
              </span>
            </vb-checkbox-group>
          </div>
        </div>
        <div class="position-relative row form-group prop-elems">
          <label class="col-sm-6 col-form-label" for="input-date-format"
            >{{ 'INPUT_DATE_FORMAT' | translate }}
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              appendTo="body"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              [pTooltip]="'INPUT_DATE_FORMAT_TOOLTIP' | translate"
            ></i
          ></label>
          <div class="col-sm-6 input-ctrl pl-0" id="input-date-format">
            <p-multiselect
              resetFilterOnHide="true"
              [options]="dateFormatOps"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [(ngModel)]="imp.dateFormat"
              class="form-control form-control-sm input-number-format-wrapper"
              [placeholder]="'SELECT' | translate"
              [disabled]="disableField"
              (onChange)="onformatChanges($event, imp, 'date')"
            >
            </p-multiselect>
          </div>
        </div>
        <div class="position-relative row form-group prop-elems">
          <label class="col-sm-6 col-form-label" for="input-date-time-format"
            >{{ 'INPUT_DATE_TIME_FORMAT' | translate }}
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              appendTo="body"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              [pTooltip]="'INPUT_DATE_TIME_FORMAT_TOOLTIP' | translate"
            ></i
          ></label>
          <div class="col-sm-6 input-ctrl pl-0" id="input-date-time-format">
            <p-multiselect
              resetFilterOnHide="true"
              [options]="datetimeForOps"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [filter]="true"
              filterBy="label"
              [(ngModel)]="imp.dateTimeFormat"
              class="form-control form-control-sm input-number-format-wrapper"
              [placeholder]="'SELECT' | translate"
              [disabled]="disableField"
              (onChange)="onformatChanges($event, imp, 'time')"
            >
            </p-multiselect>
          </div>
        </div>
        <div class="position-relative row form-group prop-elems">
          <label class="col-sm-6 col-form-label" for="input-number-format"
            >{{ 'INPUT_NUMBER_FORMAT' | translate }}
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              appendTo="body"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              [pTooltip]="'INPUT_NUMBER_FORMAT_TOOLTIP' | translate"
            ></i
          ></label>
          <div class="col-sm-6 input-ctrl pl-0 border-field" id="input-number-format">
            <p-multiselect
              resetFilterOnHide="true"
              [options]="numForOptions"
              optionLabel="label"
              optionValue="value"
              dataKey="displayLabel"
              appendTo="body"
              [(ngModel)]="imp.numberFormat"
              class="form-control form-control input-number-format-wrapper"
              [placeholder]="'SELECT' | translate"
              [disabled]="disableField"
              (onChange)="onformatChanges($event, imp, 'number')"
            >
            </p-multiselect>
          </div>
        </div>
        <div class="position-relative row form-group prop-elems radio-wrapper">
          <label class="col-sm-6 col-form-label" [for]="imp.ifRecExist"
            >{{ 'IF_RECORD_EXIST' | translate }}
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              appendTo="body"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              [pTooltip]="'IF_RECORD_EXIST_TOOLTIP' | translate"
            ></i
          ></label>
          <div class="col-sm-6 d-flex input-ctrl pl-0">
            <div *ngFor="let option of recExistOptions" class="field-radiobutton">
              <p-radiobutton
                [name]="imp.ifRecExist"
                [(ngModel)]="imp.ifRecExist"
                [value]="option.value"
                [disabled]="disableField"
                [inputId]="option.value"
                (onClick)="setValueOnChanges($event, imp)"
              ></p-radiobutton>
              <label class="mb-0 ml-1 mr-2" [for]="option.value">{{ option.name }}</label>
            </div>
          </div>
        </div>
        <div class="position-relative row form-group prop-elems radio-wrapper">
          <label class="col-sm-6 col-form-label" for="who-can-import"
            >{{ 'WHO_CAN_IMPORT' | translate }}
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              appendTo="body"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              [pTooltip]="'WHO_CAN_IMPORT_TOOLTIP' | translate"
            ></i
          ></label>
          <div class="col-sm-6 d-flex input-ctrl pl-0" id="who-can-import">
            <vb-role-lookup
              [element]="element"
              [(ngModel)]="imp.roles"
              [importProp]="true"
              [disableField]="disableField"
              (ngModelChange)="setValueOnChanges($event, imp)"
            ></vb-role-lookup>
          </div>
        </div>
        <div class="position-relative row form-group import prop-elems">
          <label class="col-sm-6 col-form-label" [for]="imp.batchSize"
          >{{ 'BATCH_SIZE' | translate }}
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              appendTo="body"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              [pTooltip]="'BATCH_SIZE_TOOLTIP' | translate"
            ></i
            ></label>
          <div class="col-sm-6 d-flex input-ctrl pl-0">
            <div class="p-inputgroup input-group size-dropdown-container">
              <p-inputNumber
                [(ngModel)]="imp.batchSize"
                [id]="imp.batchSize"
                [disabled]="disableField"
                (focusout)="onbatchSzChange($event, imp)"
                class="num-ctrl batch-ip"
              ></p-inputNumber>
              <div class="input-group-append">
                <p-button
                  type="button"
                  pRipple
                  icon="pi pi-minus-circle"
                  (onClick)="increDecBatchSz($event, imp, '-')"
                  class="opr-style ml-1 mr-1 increment"
                  tooltipPosition="top"
                  showDelay="100"
                  hideDelay="100"
                  tooltipStyleClass="label-tooltip custom-tooltip-properties"
                  tooltipEvent="hover"
                  [pTooltip]="'DECREMENT_BATCH_SIZE' | translate"
                  [disabled]="disableField"
                />
                <p-button
                  type="button"
                  pRipple
                  icon="pi pi-plus-circle"
                  (onClick)="increDecBatchSz($event, imp, '+')"
                  class="opr-style ml-0 mr-2 decrement"
                  tooltipPosition="top"
                  showDelay="100"
                  hideDelay="100"
                  tooltipEvent="hover"
                  tooltipStyleClass="label-tooltip custom-tooltip-properties"
                  [pTooltip]="'INCREMENT_BATCH_SIZE' | translate"
                  [disabled]="disableField"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="position-relative row form-group prop-elems radio-wrapper">
          <label class="col-sm-6 col-form-label" [for]="imp.onImportErr"
            >{{ 'ON_IMPORT_ERROR' | translate }}
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              appendTo="body"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              [pTooltip]="'ON_IMPORT_ERROR_TOOLTIP' | translate"
            ></i
          ></label>
          <div class="col-sm-6 d-flex input-ctrl pl-0">
            <div class="field-radiobutton">
              <p-radiobutton
                [name]="imp.onImportErr"
                [(ngModel)]="imp.onImportErr"
                value="terminate_import"
                [inputId]="terminate_import"
                (onClick)="setValueOnChanges($event, imp)"
                [disabled]="disableField"
              ></p-radiobutton>
              <label class="mb-0 ml-1 mr-2" [for]="terminate_import">{{ 'TERMINATE_IMPORT' | translate }}</label>
            </div>
            <div class="field-radiobutton">
              <p-radiobutton
                [name]="imp.onImportErr"
                [(ngModel)]="imp.onImportErr"
                value="exclude_error_rows_and_import"
                [inputId]="exclude_error_rows_and_import"
                (onClick)="setValueOnChanges($event, imp)"
                [disabled]="disableField"
              ></p-radiobutton>
              <label class="mb-0 ml-1 mr-2" [for]="exclude_error_rows_and_import">{{ 'EXCLUDE_ERROR_ROWS_AND_IMPORT' | translate }}</label>
            </div>
          </div>
        </div>
        <div class="position-relative row form-group prop-elems radio-wrapper" *ngIf="isBusinessRulesEnabled">
          <label class="col-sm-6 col-form-label" for="imp.runtimeBusinessRuleOption"
            >{{ 'RUNTIME_BUSINESS_RULE_EVENTS' | translate }}
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              appendTo="body"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              [pTooltip]="'RUNTIME_BUSINESS_RULE_EVENTS_TOOLTIP' | translate"
            ></i>
          </label>
          <div class="col-sm-6 d-flex input-ctrl pl-0">
            <div *ngFor="let option of runtimeBusinessRuleOption" class="field-radiobutton">
              <p-radioButton
                [name]="imp.runtimeBusinessRuleOption"
                [(ngModel)]="imp.runtimeBusinessRuleOption"
                [value]="option.value"
                [disabled]="disableField"
                [inputId]="option.value"
                (onClick)="setValueOnChanges($event, imp)"
              ></p-radioButton>
              <label class="mb-0 ml-1 mr-2" [for]="option.value">{{ option.name }}</label>
            </div>
          </div>
        </div>
      </p-accordion-content>
    </p-accordion-panel>
  }
</p-accordion>
<p-dialog
  [(visible)]="showPickList"
  [modal]="true"
  (onHide)="closeDialog($event)"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '60vw' }"
  appendTo="body"
  [closable]="false"
>
  <ng-template pTemplate="header">
    <div class="dialog-header">
      {{ tableName }} - {{ 'SELECT_REORDER_IMP' | translate }} :
      <span class="dialog-subheader">{{ currentImp.name }}</span>
    </div>
  </ng-template>
  <p-picklist
    [source]="source"
    [target]="target"
    [responsive]="true"
    [sourceHeader]="'AVAILABLE_FIELDS' | translate"
    [targetHeader]="'SELECTED_FIELDS' | translate"
    filterBy="searchValue"
    [sourceFilterPlaceholder]="'SEARCH_BY_NAME' | translate"
    (onTargetSelect)="ontargetSelect($event)"
    (onTargetReorder)="onTargetReorder($event)"
    [targetFilterPlaceholder]="'SEARCH_BY_NAME' | translate"
    (onMoveToTarget)="onMoveToTarget($event)"
    (onMoveAllToTarget)="onMoveToTarget($event)"
    (onMoveToSource)="onMoveToSource($event)"
    (onMoveAllToSource)="onMoveToSource($event)"
    [disabled]="disableField"
    *ngIf="showPickList"
  >
    <ng-template let-property #item>
      <div class="property-detail">
        <div class="d-flex align-items-center justify-content-between">
          <div class="header">
            <input
              (keydown)="stopPropagation($event)"
              class="alt-txt"
              type="text"
              #inputField
              alphaNumWithSpace
              *ngIf="property.edit"
              [ngClass]="{ 'bor-err': property.err }"
            />
            <span *ngIf="property.edit" class="ml-1">
              <span
                class="ml-1 pick-icons p-button-icon pi pi-check"
                (click)="saveFieldName(property)"
                aria-hidden="true"
              ></span>
              <span
                class="ml-1 pick-icons p-button-icon pi pi-times"
                (click)="cancelEdit(property)"
                aria-hidden="true"
              ></span>
            </span>
            <div *ngIf="property.altName && !property.edit" class="alt-name">{{ property.altName }}</div>
            <div [ngClass]="{ 'sub-text mt-1': property.altName }">{{ fieldIdMap[property.sid] }}</div>
          </div>
          <span
            class="ml-2 pick-icons p-button-icon pi pi-pencil"
            *ngIf="property.allowEdit && !property.edit"
            (click)="editFieldName(property)"
            aria-hidden="true"
            showDelay="100"
            hideDelay="100"
            tooltipStyleClass="label-tooltip custom-tooltip-properties"
            [pTooltip]="'PROVIDE_ALTERNATE_NAME_TOOLTIP' | translate"
            tooltipPosition="top"
          ></span>
        </div>
      </div>
    </ng-template>
    <ng-template #emptymessagesource>
      <div class="property-detail text-center">
        <span>{{ 'NO_FIELDS_AVAILABLE' | translate }}</span>
      </div>
    </ng-template>
    <ng-template #emptymessagetarget>
      <div class="property-detail text-center">
        <span>{{ 'NO_FIELDS_AVAILABLE' | translate }}</span>
      </div>
    </ng-template>
  </p-picklist>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-primary cancel-btn" (click)="closeDialog($event)">
      {{ 'CANCEL' | translate }}
    </button>
    <button type="button" class="btn btn-primary btn-sm" (click)="savePicklist()" [disabled]="disableField">
      {{ 'SAVE' | translate }}
    </button>
  </ng-template>
</p-dialog>
